import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px 24px',
    gridTemplateAreas: '"input1" "text" "input3"',
    gridTemplateColumns: '1fr',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: '16px',
    },
});
